import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import { OverviewPageHeader } from '@/components-biz/OverviewPageHeader';

import Charts from './charts';
import Detail from './detail';
import Summary from './summary';

const Container = styled.div`
  margin-bottom: 24px;
  h3 {
    margin-top: 0;
    margin-bottom: 10px;
  }
`;

const Container1 = styled.div`
  h3 {
    margin-top: 0;
    margin-bottom: 10px;
  }
`;

function Overview() {
  const { t } = useTranslation();
  return (
    <>
      <OverviewPageHeader
        title={t('hooks:compute.overview.billing.center')}
        description={t('hooks:compute.overview.description.billing')}
      />
      <Container>
        <h3>{t('tenant:account.overview')}</h3>
        <Summary />
      </Container>
      <Container>
        <Charts />
      </Container>
      <Container1>
        <h3>{t('hooks:transaction.details')}</h3>
        <Detail />
      </Container1>
    </>
  );
}

export { Overview };
